import { render, staticRenderFns } from "./Rappel.vue?vue&type=template&id=e7d70cfc&scoped=true&lang=true&"
import script from "./Rappel.vue?vue&type=script&lang=js&"
export * from "./Rappel.vue?vue&type=script&lang=js&"
import style0 from "./Rappel.vue?vue&type=style&index=0&id=e7d70cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7d70cfc",
  null
  
)

export default component.exports